import React from 'react';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import CashWalletConstants from './CashWalletConstants';

const { REQUEST_STATUS } = CashWalletConstants;
const CANCELLED_COLOR = '#919595';

const StatusIndicator = ({ status }) => {
    const { t } = useTranslation('CashWallet');
    const theme = useTheme();

    const colorByStatus = {
        [REQUEST_STATUS.PAID]: theme.palette.success.main,
        [REQUEST_STATUS.REJECTED]: theme.palette.danger.main,
        [REQUEST_STATUS.SUBMITTED]: theme.palette.primary.main,
        [REQUEST_STATUS.CANCELLED]: CANCELLED_COLOR,
    };

    const color = colorByStatus[status] || CANCELLED_COLOR;

    return (
        <span className="cash-wallet-status">
            <span className="cash-wallet-status-dot" style={{ backgroundColor: color }} />
            <span className="cash-wallet-status-label" style={{ color }}>
                {t(`Requests.Status.${status}`)}
            </span>
        </span>
    );
};

export default StatusIndicator;
